export default 'browser';
